import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

import authentication from '@/assets/js/Authentication'
import middlewarePipeline from '@/middleware'
import auth from '@/middleware/Auth'
import admin from '@/middleware/Admin'
import owner from '@/middleware/Owner'
import employee from '@/middleware/Employee'
import memberRouter from './member'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    title: 'Home',
    icon: 'mdi-home',
    component: () => import('@/views/Home.vue'),
    meta: {
      middleware: {
        auth,
        admin,
        owner,
        employee
      }
    }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    title: 'Dashboard',
    icon: 'mdi-view-dashboard-outline',
    component: () => import('@/views/Dashboard.vue'),
    meta: {
      middleware: {
        auth,
        admin,
        owner
      }
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue'),
    layout: 'Blank',
    hide: true
  },
  {
    path: '/logout',
    name: 'Logout',
    component: () => import('@/views/logout'),
    layout: 'Blank',
    hide: true
  },
  memberRouter,
  {
    path: '/*',
    name: 'PageNotFound',
    component: () => import('@/views/Dashboard.vue'),
    layout: 'Blank',
    hide: true
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  if (store.getters['Style/errorPage']) {
    store.dispatch('Style/setErrorPage', 0)
  }
  if (to.name === 'PageNotFound') {
    store.dispatch('Style/setErrorPage', 404)
  }
  if (!to.meta.middleware) {
    return next()
  }
  const { middleware } = to.meta

  const context = {
    to,
    from,
    router,
    store,
    next,
    routerNext: next,
    auth: authentication
  }

  return Object.values(middleware)[0]({
    ...context,
    next: middlewarePipeline(context, middleware, 1)
  })
})

const filterRouter = (routers) => {
  const results = []
  routers.forEach((r) => {
    let { children } = r
    if (!r.hide) {
      if (children) {
        children = filterRouter(children)
        results.push({ ...r, children })
      } else {
        results.push(r)
      }
    }
  })
  return results
}

const menus = filterRouter(routes)

export default router

export { menus }
